const numberToHex = (color: number): string =>
  Math.trunc(color).toString(16).padStart(2, '0');
export const rgbToHex = (red: number, green: number, blue: number): string =>
  `#${numberToHex(red)}${numberToHex(green)}${numberToHex(blue)}`;

export function clamp(input: number, min: number, max: number): number {
  return input < min ? min : input > max ? max : input;
}

export function rangeConvert(
  current: number,
  in_min: number,
  in_max: number,
  out_min: number,
  out_max: number
): number {
  const mapped: number =
    ((current - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
  return clamp(mapped, out_min, out_max);
}
